import * as React from 'react';
import IAgreementProducts from './IAgreementProducts';

interface AgreementProductsListRowProps {
    agreementProducts: IAgreementProducts;
    key: number;
}

const AgreementProductsListRow = (props: AgreementProductsListRowProps) => {
    return (
        props && (
            <tr>
                <td>{props.agreementProducts.name}</td>
                <td>{props.agreementProducts.compensation}</td>
            </tr>
        )
    );
};

export default AgreementProductsListRow;
